export const QUERY__CURRENCIES = 'currencies';
export const QUERY__PAYMENT_CURRENCIES = 'payment-currencies';
export const QUERY__CURRENCY_EVENT_SCHEDULES = 'currency-event-schedules';
export const QUERY__CRYPTO_EVENT_TEMPLATES = 'crypto-event-templates';
